import {LoginType} from '@Components/two-factor-authentication/two-factor-authentication.types';

export const isBackupCodeLoginType = (loginType: LoginType): boolean => {
  return loginType === LoginType.BACKUP_CODE;
};

export const isTOTPLoginType = (loginType: LoginType): boolean => {
  return loginType === LoginType.TOTP;
};

/**
 * The login page verifies 2FA in an inline panel rather than a modal, so the caller cannot hand it a
 * success handler as a prop. Callers park one here before switching the panel on, and the panel consumes
 * it once — a closure cannot live in the redux store, and the alternative is threading it through every
 * auth entry point.
 */
let pendingVerificationSuccessCallback: (() => void) | null = null;

export const setPendingTwoFactorVerificationCallback = (callback: (() => void) | null): void => {
  pendingVerificationSuccessCallback = callback;
};

export const consumePendingTwoFactorVerificationCallback = (): (() => void) | null => {
  const callback = pendingVerificationSuccessCallback;
  pendingVerificationSuccessCallback = null;
  return callback;
};
